import serverVars from 'server-vars';
import { getAbTestV2 } from './clientAbTestV2';
import { PAGE_TYPE, BROWSE_TYPES } from 'dibs-constants/exports/pageTypes';

export const APP_DOWNLOAD_MODAL_TEST_NAME = 'appDownloadModal' as const;

export const isAppDownloadAbTestVariant = (): boolean =>
    getAbTestV2(APP_DOWNLOAD_MODAL_TEST_NAME)?.variant === 'variant';

const allowedPageTypes = [
    PAGE_TYPE.HOME,
    PAGE_TYPE.CREATOR,
    PAGE_TYPE.DEALER,
    PAGE_TYPE.PDP,
    PAGE_TYPE.SEARCH,
    ...BROWSE_TYPES,
];
const pageType = serverVars.get('settings.pageType');
export const isAllowedAppDownloadPageType = allowedPageTypes.includes(pageType);
